export default "__VITE_ASSET__Cwlf4s0O__"